
import { Component, Emit, Vue, Prop } from 'vue-property-decorator'

@Component
export default class AppButton extends Vue {
    @Prop() private size!: string

    @Emit('click')
    public onClick(e: Event) {
        e.stopPropagation()
        return e
    }
}
